<template>
  <div>
    <v-card :disabled="isProcessing" :loading="isProcessing">
      <template v-slot:progress>
        <v-progress-linear absolute color="success" height="4" indeterminate></v-progress-linear>
      </template>
      <v-tabs v-model="tab" class="stock-color" left dark icons-and-text>
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1">
          <v-toolbar-title>{{ $t("STOCK.REVISIONS.TITLE") }}</v-toolbar-title>
        </v-tab>
        <v-spacer></v-spacer>
        <div class="buttons-tab">
          <v-btn
            v-if="hasPermissions('stock-revisions-edit')"
            class="mr-2 teal darken-1"
            :disabled="isProcessing"
            @click="$router.push({ name: 'stock-revisions-edit-last' })"
          >
            {{ $t("STOCK.REVISIONS.EDIT_LAST") }}
          </v-btn>
          <v-btn
            v-if="hasPermissions('stock-revisions-create')"
            class="mr-4 success"
            :disabled="isProcessing"
            @click="$router.push({ name: 'stock-revisions-create' })"
          >
            {{ $t("STOCK.REVISIONS.NEW") }}
          </v-btn>
        </div>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <v-card flat>
            <v-card-text class="pb-0 pt-3">
              <div class="caption grey--text text--darken-1">
                {{ $t("STOCK.REVISIONS.LIST_SUBTITLE") }}
              </div>
            </v-card-text>
            <v-card-text class="pa-0">
              <Table
                v-if="userStatePrepared"
                ref="stock-revisions-table"
                height="500"
                name="stock-revisions-table"
                :headers="headers"
                :server-data-options="{ method: tableItemsMethod }"
                :items-per-page="25"
                :loading="isProcessing"
                :filters="tableFilters"
                dense
                fixed-header
                filterable
              >
                <template
                  v-for="(header, index) in headers"
                  v-slot:[`item.${header.value}`]="{ item }"
                >
                  <template v-if="header.value === 'code'">
                    <router-link
                      :key="index"
                      :to="{ name: 'stock-revisions-view', params: { id: item.item.id } }"
                    >
                      {{ item.item.code }}
                    </router-link>
                  </template>
                  <template v-else-if="header.value === 'status'">
                    <v-chip :key="index" small :color="statusColor(item.item.status)" dark>
                      {{ statusLabel(item.item.status) }}
                    </v-chip>
                  </template>
                  <template v-else-if="header.value === 'warehouse.label'">
                    {{ warehouseLabel(item.item) }}
                  </template>
                  <template v-else-if="header.value === 'organization.name'">
                    {{ organizationLabel(item.item) }}
                  </template>
                  <template v-else-if="header.value === 'stock_action.code'">
                    <span :key="index">
                      <router-link
                        v-if="item.item.stock_action"
                        :to="{
                          name: 'stock-receipts-view',
                          params: { id: item.item.stock_action.id },
                        }"
                      >
                        {{ item.item.stock_action.code }}
                      </router-link>
                      <template v-else>-</template>
                    </span>
                  </template>
                  <template v-else-if="header.value === 'finalized_by_user.name'">
                    {{ (item.item.finalized_by_user && item.item.finalized_by_user.name) || "-" }}
                  </template>
                  <template v-else>
                    {{ item.value != null && item.value !== "" ? item.value : "-" }}
                  </template>
                </template>
              </Table>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import Table from "@/views/partials/v-table/Table.vue";
import { GET_STOCK_REVISIONS } from "@/store/stock/stockRevisions.module";
import stockRevisionDisplayMixin from "@/views/partials/stock/revisions/stockRevisionDisplay.mixin";

export default {
  name: "StockListRevisions",
  components: { Table },
  mixins: [stockRevisionDisplayMixin],
  data() {
    return {
      tab: "tab-1",
      userStatePrepared: false,
      isProcessing: false,
      tableItemsMethod: GET_STOCK_REVISIONS,
      tableFilters: [],
      headers: [
        {
          text: this.$t("STOCK.REVISIONS.CODE"),
          value: "code",
          sortable: true,
          align: "center",
          width: "12%",
        },
        {
          text: this.$t("GENERAL.LABELS.STATUS"),
          value: "status",
          sortable: false,
          align: "center",
          width: "9%",
        },
        {
          text: this.$t("STOCK.REVISIONS.FOR_DATE"),
          value: "for_date",
          sortable: true,
          align: "center",
          width: "10%",
        },
        {
          text: this.$t("STOCK.REVISIONS.WAREHOUSE"),
          value: "warehouse.label",
          sortable: false,
          align: "center",
          width: "16%",
        },
        {
          text: this.$t("STOCK.WAREHOUSES.ORGANIZATION"),
          value: "organization.name",
          sortable: false,
          align: "center",
          width: "11%",
        },
        {
          text: this.$t("STOCK.REVISIONS.SUMMARY.TOTAL_ROWS"),
          value: "items_count",
          sortable: false,
          align: "center",
          width: "8%",
        },
        {
          text: this.$t("STOCK.REVISIONS.SUMMARY.COUNTED_ROWS"),
          value: "counted_items_count",
          sortable: false,
          align: "center",
          width: "8%",
        },
        {
          text: this.$t("STOCK.REVISIONS.SUMMARY.VARIANCE_ROWS"),
          value: "variance_items_count",
          sortable: false,
          align: "center",
          width: "8%",
        },
        {
          text: this.$t("STOCK.REVISIONS.FINALIZED_MOVEMENT"),
          value: "stock_action.code",
          sortable: false,
          align: "center",
          width: "10%",
        },
        {
          text: this.$t("STOCK.REVISIONS.FINALIZED_BY"),
          value: "finalized_by_user.name",
          sortable: false,
          align: "center",
          width: "8%",
        },
      ],
    };
  },
  computed: {
    stockContextVersion() {
      return this.$store.getters.stockContextVersion;
    },
  },
  watch: {
    stockContextVersion() {
      this.reloadTable();
    },
  },
  mounted() {
    this.tableFilters = [
      {
        key: "status",
        label: this.$t("GENERAL.LABELS.STATUS"),
        type: "select",
        "item-value": "id",
        "item-text": "label",
        items: ["draft", "finalized", "cancelled"].map((status) => ({
          id: status,
          label: this.statusLabel(status),
        })),
      },
      {
        key: "for_date_from",
        label: this.$t("STOCK.REVISIONS.FOR_DATE_FROM"),
        type: "date",
      },
      {
        key: "for_date_to",
        label: this.$t("STOCK.REVISIONS.FOR_DATE_TO"),
        type: "date",
      },
    ];
    this.userStatePrepared = true;
  },
  methods: {
    reloadTable() {
      this.$nextTick(() => {
        this.$refs["stock-revisions-table"]?.fetchServerData();
      });
    },
  },
};
</script>
